import { render, staticRenderFns } from "./AdminDetailAccess.vue?vue&type=template&id=0748347e&"
import script from "./AdminDetailAccess.vue?vue&type=script&lang=js&"
export * from "./AdminDetailAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports